import React, { useEffect } from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { saveRedirectUrl } from '../lib/authRedirect';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect if this is a shared route (should never happen, but safety check)
    if (location.pathname.startsWith('/shared/')) {
      return;
    }
    
    // If not loading and no user, redirect to auth
    if (!loading && !user) {
      // Store the attempted URL to redirect back after login
      saveRedirectUrl(location.pathname + location.search + location.hash);
      navigate('/auth', { replace: true });
    }
  }, [loading, user, navigate, location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-electric" />
      </div>
    );
  }

  if (!user) {
    return null; // Let the useEffect handle redirect
  }

  return <>{children}</>;
}